import './style.scss'
import $ from 'jquery'

$(function () {
    $('.ow_zgodovina__item_read_more').on('click', function (event) {
        event.preventDefault()
        event.stopPropagation()
        $(this).slideToggle('fast')
        $(this)
            .parent()
            .find('.ow_zgodovina__item_read_less')
            .slideToggle('fast')
        $(this).parent().find('.ow_zgodovina__item_more').slideToggle('fast')
    })
    $('.ow_zgodovina__item_read_less').on('click', function (event) {
        event.preventDefault()
        event.stopPropagation()
        $(this).slideToggle('fast')
        $(this)
            .parent()
            .find('.ow_zgodovina__item_read_more')
            .slideToggle('fast')
        $(this).parent().find('.ow_zgodovina__item_more').slideToggle('fast')
    })
});

/*
(function() {
    const root = document.querySelector('#wrapper')

    const callback = (entries) => { 
      entries.forEach(entry => {
        console.log(entry.isIntersecting, entry.target);
      });
    };

    const observer = new IntersectionObserver(callback, {
        root: null,
        rootMargin: '100px',
        threshold: 1.0,
    });

    observer.observe(document.querySelector('#zgodovina_zgodovina'));
    observer.observe(document.querySelector('#zgodovina_nagrade'));
    observer.observe(document.querySelector('#zgodovina_projekti'));

})()
*/

/*
$(window).on('scroll load', setLineHeight)

function setLineHeight() {
    const $line = $(".ow_zgodovina__line_inner")
    if ($line.length > 0) {
        const middle = window.innerHeight / 2
        const rect = $line.get(0).getBoundingClientRect()
        const height = rect.top < middle ? middle - rect.top : 0;
        $line.css({ height })
    }
}
*/
